export default __webpack_public_path__ + "static/PromptIconFive-af84ff49f8659247da8641acead00171.png";